import { createContext } from "react";

export const OpacSettingContext = createContext(false);
